export const NUMBER_OF_TRIES = 8
export const CARDS_PER_TRY = 4
export const WINING_COMBINATION_LENGTH = CARDS_PER_TRY
export const CARDS: ReadonlyMap<string, number> = new Map([
  ['ocean', 6],
  ['orange', 6],
  ['vanilla', 5],
  ['love', 5],
  ['tulip', 5],
  ['leaf', 5],
])
export const MOVE_CARD_ANIMATION_DURATION = 1200
